import React from 'react';
import { AgentGroup, AgentPreference, LOCKED_AGENT_IDS } from './agentsModalTypes';
import { countEnabledAgents } from './agentsModalUtils';

interface GroupControlsProps {
  group: AgentGroup;
  enabledMap: Record<string, AgentPreference>;
  onSelectAll: (groupId: string, value: boolean) => void;
  projectAgents?: Record<string, AgentPreference>;
  isTaskContext?: boolean;
}

export const GroupControls: React.FC<GroupControlsProps> = ({
  group,
  enabledMap,
  onSelectAll,
  projectAgents,
  isTaskContext,
}) => {
  const enabledCount = countEnabledAgents(group.agents, enabledMap);
  const totalCount = group.agents.length;
  const selectableAgents = group.agents.filter((agent) => {
    if (LOCKED_AGENT_IDS.has(agent.id)) return false;
    if (isTaskContext && projectAgents && projectAgents[agent.id]?.enabled === false) return false;
    return true;
  });
  const selectableEnabledCount = countEnabledAgents(selectableAgents, enabledMap);
  const selectableTotalCount = selectableAgents.length;

  return (
    <div className="agents-modal__group-controls">
      <span className="agents-modal__group-count">
        {enabledCount}/{totalCount} enabled
      </span>
      <button
        type="button"
        className="agents-modal__control-btn"
        onClick={() => onSelectAll(group.id, true)}
        disabled={selectableTotalCount === 0 || selectableEnabledCount === selectableTotalCount}
      >
        All
      </button>
      <button
        type="button"
        className="agents-modal__control-btn"
        onClick={() => onSelectAll(group.id, false)}
        disabled={selectableTotalCount === 0 || selectableEnabledCount === 0}
      >
        None
      </button>
    </div>
  );
};
